import common from './common'

export default {
    listMeetingCostCenter(params) {
      return common.get('/rocheManage/external/externalCostCenter/getMeetingCostCenterList',params);
    },

    listExistCostCenter(params) {
      return common.get('/rocheManage/external/externalCostCenter/getExistCostCenter',params);
    },

    listExternalCostCenter(params) {
        params.pageIndex = 1;
        params.pageSize = 1000000;
      return common.get('/rocheManage/external/externalCostCenter/getCostCenter',params);
    },

    listExternalWbsCode(params) {
        params.pageIndex = 1;
        params.pageSize = 1000000;
      return common.get('/rocheManage/external/externalCostCenter/getWbs',params);
    },

    listLocalCostCenter(params) {
      return common.get('/rocheManage/external/externalCostCenter/getCostCenterList',params);
    },

    listLocalWbsCode(params) {
      return common.get('/rocheManage/external/externalCostCenter/getWbsCodeList',params);
    },

    listRealWbsCode(params) {
      return common.get('/rocheManage/external/externalCostCenter/getMeetingRealWbsList',params);
    },
}


// WEBPACK FOOTER //
// ./src/api/costCenterAndWbs.js